/** Shared by the header and body rows so columns line up. */
export const FILE_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: 'minmax(260px, 2.2fr) minmax(180px, 1.4fr) 100px 150px 152px',
  alignItems: 'center',
  columnGap: 1.5,
  pl: 2.5,
  pr: 1.5,
} as const;
